import { useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@jana-technology/platform-ui";

import { LoadingSpinner } from "components/loaders";
import { useOutcomeScenariosContext } from "contexts/scenarios";
import { SidebarSpacer, SidebarComponentHeading } from "components/sidebar";

export const OutcomeScenariosSelect = () => {
  const params = useParams<{ failureModeEffect: string }>();

  const decodedFailureModeParam = decodeURIComponent(
    params?.failureModeEffect ?? "",
  );

  const { loading, scenarios, selectedScenario, onScenarioSelect } =
    useOutcomeScenariosContext();

  // init with with route param or first scenario
  useEffect(() => {
    if (scenarios.length) {
      const { value } =
        scenarios.find(
          (scenario) => scenario.value === decodedFailureModeParam,
        ) ?? scenarios[0];

      onScenarioSelect(value);
    }
  }, [decodedFailureModeParam, onScenarioSelect, scenarios]);

  return (
    <LoadingSpinner loading={loading} className="h-10">
      <SidebarSpacer>
        <SidebarComponentHeading>Outcome Scenario:</SidebarComponentHeading>
        {Boolean(selectedScenario) && (
          <Select value={selectedScenario} onValueChange={onScenarioSelect}>
            <SelectTrigger className="w-full" id="risk-mitigation-select">
              <SelectValue placeholder="Select one" />
            </SelectTrigger>
            <SelectContent>
              {scenarios.map((scenario) => (
                <SelectItem key={scenario.value} value={scenario.value}>
                  {scenario.children}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
      </SidebarSpacer>
    </LoadingSpinner>
  );
};

export default OutcomeScenariosSelect;
